import React from 'react';
import {useMutation} from '@tanstack/react-query';
import {request} from '../../lib/request';
import {Button} from '@heroui/react';
import {getErrorMessage, toastError, toastSuccess} from '../../lib/toast';
import CancelDelivery from './CancelDelivery';

const resolveAction = (isPike, orderStatus) => {
    if (isPike) {
        if (orderStatus === 'processing') {
            return {nextStatus: 'completed', label: 'درخواست پیک'};
        }
        if (orderStatus === 'completed') {
            return {nextStatus: 'delivery', label: 'ارسال'};
        }
        return null;
    }

    if (orderStatus === 'processing') {
        return {nextStatus: 'delivery', label: 'ارسال'};
    }

    return null;
};

const GetPike = ({id, refetch, buttonColor, isPike, orderStatus}) => {
    const isDelivered = orderStatus === 'delivery';
    const action = resolveAction(isPike, orderStatus);

    const {mutate, isPending} = useMutation({
        mutationFn: async (data) =>
            await request({
                url: '/restaurant/order/complete',
                method: 'post',
                data,
            }),
        onSuccess: (data) => {
            toastSuccess(data.message);
            refetch();
        },
        onError: (error) => {
            toastError(getErrorMessage(error));
        },
    });

    const handleConfirm = () => {
        if (!action || isPending || isDelivered) return;
        mutate({status: action.nextStatus, order_id: id});
    };

    if (isDelivered) {
        return (
            <CancelDelivery
                id={id}
                refetch={refetch}
                revertStatus={isPike ? 'completed' : 'processing'}
                buttonColor={buttonColor}
            />
        );
    }

    if (!action) {
        return null;
    }

    return (
        <Button
            isLoading={isPending}
            isDisabled={isPending}
            type="button"
            onPress={handleConfirm}
            className={`${buttonColor} rounded-lg font-medium`}
        >
            {action.label}
        </Button>
    );
};

export default GetPike;
